import React from 'react';
import { Helmet } from "react-helmet";

//CORE COMPOENTNS
import { ThemeProvider, styled } from '../../../components-core/packages/components-core/dist/theme-provider';
import scroll from '../lead-section/LeadSection'
//LAYOUT
import {
    Container,
    ContainerGutter,
    ContainerWrap,
    ContainerPadding,
    ContainerHorizontalAlignment
} from '../../../components-core/packages/components-core/dist/container';
import { Breakpoints } from '../../../components-core/packages/components-core/dist/helpers';

//STYLE
import { Text, TextAppearance, TextAlignment, TextColor } from '../../../components-core/packages/components-core/dist/text';
import { Button, ButtonAppearance } from '../../../components-core/packages/components-core/dist/button'
import LayoutTwo from '../../components/layouttwo'
import { Link } from '../../../components-core/packages/components-core/dist/link/index';

import { Image } from '../../../components-core/packages/components-core/dist/image/index';

import { Layout } from '../../../components-core/packages/components-core/dist/layout/index';
import { IntegratorRoot } from '../../../components-core/packages/components-core/dist/integrator-root/index';
import crafter from './crafter-okul.png'

const TopContainer = styled.div`
    width: 100vw;
    
    display: flex;
    align-items: center;
    justify-content: center;
    overflow: hidden;

`;

class UserListCars extends React.Component {

    constructor() {
        super();
        this.state = {
            isHaveCar:true
        }

        this.staticContainerPaddingVertical = { 
            top: ContainerPadding.grid001, 
        }

        this.staticContainerPaddingHorizontal = {
            left: ContainerPadding.grid002,
            right: ContainerPadding.grid002,
            ...this.staticContainerPaddingVertical
        }


        const centerAlignnment = TextAlignment.center;

        this.textAlign = {
            [Breakpoints.b2560]: centerAlignnment,
            [Breakpoints.b1920]: centerAlignnment,
            [Breakpoints.b1600]: centerAlignnment,
            [Breakpoints.b1280]: centerAlignnment,
            [Breakpoints.b960]: centerAlignnment,
        }

        const grid004Padding = ContainerPadding.grid004;
        const grid002Padding = ContainerPadding.grid002;

        const imagePadding = {
            [Breakpoints.b2560]: grid004Padding,
            [Breakpoints.b1920]: grid004Padding,
            [Breakpoints.b1600]: grid004Padding,
            [Breakpoints.b1280]: grid004Padding,
            [Breakpoints.b960]: grid002Padding,
        }

        this.image4DimensionsPadding = {
            left: imagePadding,
            right: imagePadding,
            top: ContainerPadding.dynamic0100
        }
    }

    renderTitle() {

        return (
            <Container 
                padding={padding4Dimensions} 
                horizontalAlign={ContainerHorizontalAlignment.center}
            >
                <h2><Text textAlign={TextAlignment.center} bold appearance={TextAppearance.headline0300}>
                   Aracınız burada görünmüyor mu?
                </Text></h2>
            </Container>
        )
    }

    renderDescription() {

        return (
            <Container 
                padding={padding4Dimensions} 
                horizontalAlign={ContainerHorizontalAlignment.center} 
            >
                <Text textAlign={TextAlignment.center} appearance={TextAppearance.copy0200}>
                Volkswagen Ticari Araç mobil uygulamasını indirerek adınıza kayıtlı araçlarınızı ekleyebilirsiniz.
                </Text>
            </Container>
        )
    }

    renderButton() {

        return (
            <Container 
                horizontalAlign={ContainerHorizontalAlignment.center}
                padding={{ left: globalPadding, right: globalPadding }}
            >
                <Button appearance={ButtonAppearance.Primary}>
                    <Text appearance={TextAppearance.copy0150} color={TextColor.inherit}  >
                    Hemen İndir
                    </Text>  
                </Button>
            </Container>
        )
    }

    renderInnerContainer() {

        const mainContainerPadding = {
            top: ContainerPadding.dynamic0300,
            bottom: ContainerPadding.dynamic0300
        }

        return (
            <Container 
                padding={mainContainerPadding}
                horizontalAlign={ContainerHorizontalAlignment.center} 
            >
                <Container 
                    horizontalAlign={ContainerHorizontalAlignment.center}
                    stretchContent={true}
                    wrap={ContainerWrap.always}
                >
                    {this.renderTitle()}
                    {this.renderDescription()}
                    {this.renderButton()}
                </Container>
            </Container> 
        )
    }

    renderImage(){
        return (
            <Container padding={this.image4DimensionsPadding}>
                <Image src={crafter} alt={'volkswagen-ticari'} />
            </Container>
        )
    }

    renderDescriptionCar() {

        return (
            <Container wrap={ContainerWrap.always} padding={this.staticContainerPaddingVertical} >
                <Text textAlign={this.textAlign} appearance={TextAppearance.copy0150} color={TextColor.secondary}>
                    Aracınız
                </Text>
                <Text textAlign={this.textAlign}  appearance={TextAppearance.label0250} bold>
                Amarok Canyon
                </Text>
                <Text textAlign={this.textAlign}  appearance={TextAppearance.label0300} bold>
                3.0 V6 TDI 204 PS Otomatik
                </Text>
                <Text textAlign={this.textAlign}  appearance={TextAppearance.label0200} bold>
                34 J 2014
                </Text>
                                            
            </Container>
        )
    }

    render() {

        return (
            <ThemeProvider>
                <TopContainer >
                {
                    this.state.isHaveCar ? [
                <Container 
                    padding={{ 
                        top: ContainerPadding.dynamic0250, 
                        bottom: ContainerPadding.dynamic0250 
                    }}
                    horizontalAlign={ContainerHorizontalAlignment.center}
                >
                    <Container 
                        wrap={ContainerWrap.always}
                        padding={this.staticContainerPaddingHorizontal}
                    >
                        {this.renderImage()}
                        {this.renderDescriptionCar()}
                    </Container>
                </Container>
                    ] : [
                        <Container>
                        {this.renderInnerContainer()}
                        </Container>
                    ]
                }
                </TopContainer>   
            </ThemeProvider>
        )
    }


    
}

const globalPadding = {
    [Breakpoints.b1920]: ContainerPadding.grid007,
    [Breakpoints.b1600]: ContainerPadding.grid006,
    [Breakpoints.b1280]: ContainerPadding.grid005,
    [Breakpoints.b960]: ContainerPadding.grid004,
    [Breakpoints.default]: ContainerPadding.grid002
}

const padding4Dimensions = {
    left: globalPadding,
    right: globalPadding,
    bottom: ContainerPadding.dynamic0100
}

export default UserListCars;